import { render } from "./index.vue?vue&type=template&id=a4c146c4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a4c146c4&lang=css"
import "./index.vue?vue&type=style&index=1&id=a4c146c4&scoped=true&lang=css"

import exportComponent from "/Users/zhouti/Desktop/work/fy-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4c146c4"]])

export default __exports__